module.exports = __webpack_public_path__ + "static/img/task_icon.1db45db.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/task_icon.png
// module id = Rup3
// module chunks = 37